import { render, staticRenderFns } from "./logcarshipview.vue?vue&type=template&id=c57553b8&scoped=true&"
import script from "./logcarshipview.vue?vue&type=script&lang=js&"
export * from "./logcarshipview.vue?vue&type=script&lang=js&"
import style0 from "./logcarshipview.vue?vue&type=style&index=0&id=c57553b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57553b8",
  null
  
)

export default component.exports